import { MENTION_TYPE } from "@/constants";
import { MentionV4 } from "@/types/MentionCard";

export function categorizeMentionsByContext(mentions: MentionV4[]) {
  const titleMention = mentions.find(
    (mention) => mention.context === MENTION_TYPE.EPISODE_NAME
  );

  const otherMentions = titleMention
    ? mentions.filter((mention) => mention.id !== titleMention?.id)
    : mentions;

  return {
    titleMention,
    otherMentions,
  };
}
